import { ProfileState } from 'types';
import { createReducer } from 'utils';
import { avatarImage } from 'assets/images';

import { profileHandlers } from './handlers';

export const profileInitialState: Readonly<ProfileState> = {
  isLoading: false,
  isSavingAvatar: false,
  avatar: avatarImage,
  lastName: '',
  firstName: '',
  fatherName: '',
  email: '',
  phone: '',
  telegram: '',
  balance: '0.00',
  id: 0,
  rank: '',
  countryProfile: '',
  isCompany: false,
  isVerified: false,
  companyName: '',
  tin: '',
  dataActive: '',
  dataDeActive: '',
  ekiQuantity: 0,
  status: null,
  raffleTickets: [],
  challenge: null,
  isQualified: false,
};

export default createReducer(profileInitialState, profileHandlers);
